<template>
    <v-tabs :value="value" centered show-arrows center-active class="tab tab--inline tab--underline-inline">
        <v-tab v-for="item in items" :key="item.text" v-bind="item" exact-path>
            <span>{{ item.name }}</span>
        </v-tab>
    </v-tabs>
</template>

<script>
import { PRIVATE_SALES_TABS } from "@/assets/variables";
export default {
    props: {
        value: { type: String, default: null },
        categories: { type: Array, default: () => [] },
        withoutAll: { type: Boolean, default: false },
    },
    computed: {
        items() {
            const items = [];
            if (!this.withoutAll) items.push({ name: "전체", to: `/private-sales/${PRIVATE_SALES_TABS.LIST.value}/groups/all` });
            items.push(...(this.categories || []).map((item) => ({ ...item, to: `/private-sales/${PRIVATE_SALES_TABS.LIST.value}/groups/${item.code}` })));
            return items;
        },
    },
};
</script>

<style></style>
